export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11839.979d5a09.jpg";